import { render, staticRenderFns } from "./invoiceSataus.vue?vue&type=template&id=9e044b90&scoped=true&"
import script from "./invoiceSataus.vue?vue&type=script&lang=js&"
export * from "./invoiceSataus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e044b90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e044b90')) {
      api.createRecord('9e044b90', component.options)
    } else {
      api.reload('9e044b90', component.options)
    }
    module.hot.accept("./invoiceSataus.vue?vue&type=template&id=9e044b90&scoped=true&", function () {
      api.rerender('9e044b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/policy/invoiceSataus.vue"
export default component.exports